var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { Textfield as CLTextfield } from 'syf-component-library/ui/atoms';
import { Inset } from 'syf-component-library/ui/spacing';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import formatUserAnswer from '../../../helpers/formatUserAnswer';
import { updateAdditionalContent, updateUserAnswers } from '../../../redux/userAnswers/userAnswers.slice';
import isValidAmount from '../../../helpers/isValidAmount';
import validateAmount from '../../../helpers/validateAmount';
import getCurrentQuestionAnswer from '../../../helpers/getCurrentQuestionAnswer';
import { clearFormError, updateAdditionalFieldFormError, updateFormError } from '../../../redux/ui/ui.slice';
import { FieldType } from '../../../redux/questionnaire/typings';
import strings from '../../../strings/i18n/en';
import Icon from '../Icon';
var CustomCLTextfield = styled(CLTextfield)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 320px;\n"], ["\n  width: 320px;\n"])));
var TextField = function (_a) {
    var _b, _c, _d, _e, _f;
    var answer = _a.answer, isAdditionalContent = _a.isAdditionalContent, additionalInputType = _a.additionalInputType, additionalPlaceHolder = _a.additionalPlaceHolder, textfieldRef = _a.textfieldRef, _g = _a.isEligibleForPartialAmount, isEligibleForPartialAmount = _g === void 0 ? false : _g, dataCy = _a.dataCy;
    var _h = useSelector(function (state) { return state; }, shallowEqual), _j = _h.ui, formError = _j.formError, additionalFieldFormError = _j.additionalFieldFormError, userAnswers = _h.userAnswers, currentQuestion = _h.questionnaire.currentQuestion, transactionAmount = _h.transactionData.transactionAmount;
    var dispatch = useDispatch();
    var localTextRef = useRef(null);
    var textRef = textfieldRef || localTextRef;
    var options = (answer === null || answer === void 0 ? void 0 : answer.answerOptions) || [];
    var nextQuestionId = (_b = options[0]) === null || _b === void 0 ? void 0 : _b.nextQuestionId;
    var answerId = (_c = options[0]) === null || _c === void 0 ? void 0 : _c.answerId;
    var disputeReason = (_d = options[0]) === null || _d === void 0 ? void 0 : _d.disputeReason;
    var script = (_e = options[0]) === null || _e === void 0 ? void 0 : _e.script;
    var TYPE_NUMBER = 'number';
    var currentQuestionAnswer = getCurrentQuestionAnswer({
        userAnswers: userAnswers,
        currentQuestion: currentQuestion
    });
    var questionType = (_f = currentQuestion.answers[0]) === null || _f === void 0 ? void 0 : _f.fieldType;
    var inputType = additionalInputType || (answer === null || answer === void 0 ? void 0 : answer.type) || 'text';
    var placeholder = isAdditionalContent
        ? additionalPlaceHolder
        : (answer === null || answer === void 0 ? void 0 : answer.placeHolder) || '';
    var answerText = isAdditionalContent
        ? currentQuestionAnswer === null || currentQuestionAnswer === void 0 ? void 0 : currentQuestionAnswer.answers[1]
        : currentQuestionAnswer === null || currentQuestionAnswer === void 0 ? void 0 : currentQuestionAnswer.answers[0];
    var handleChange = function (e) {
        var isAmount = (isAdditionalContent && inputType === TYPE_NUMBER) ||
            inputType === TYPE_NUMBER;
        // get current question, look at question options, look at meta data, pass to type
        var inputValue = e.currentTarget.value;
        if (isAmount && !isValidAmount(inputValue)) {
            return;
        }
        if (!inputValue || (inputValue === null || inputValue === void 0 ? void 0 : inputValue.trim())) {
            if (isAdditionalContent) {
                dispatch(updateAdditionalContent({
                    currentAnswerId: currentQuestionAnswer.id,
                    additionalContent: inputValue,
                    isEligibleForPartialAmount: isEligibleForPartialAmount,
                    isAmount: isAmount
                }));
            }
            else {
                var userAnswer = formatUserAnswer({
                    nextQuestionId: nextQuestionId,
                    answerId: answerId,
                    option: [inputValue],
                    currentQuestion: currentQuestion,
                    disputeReason: disputeReason,
                    isEligibleForPartialAmount: answer === null || answer === void 0 ? void 0 : answer.isEligibleForPartialAmount,
                    script: script,
                    type: isAmount ? 'AMOUNT' : 'TEXTFIELD'
                });
                dispatch(updateUserAnswers(userAnswer));
            }
        }
    };
    var handleKeyPress = function (e) {
        var ENTER_KEY = 'Enter';
        if (e.key === ENTER_KEY) {
            e.preventDefault();
        }
    };
    useEffect(function () {
        if (formError === strings.translation.formError.pleaseAnswer) {
            textRef.current.focus();
        }
    }, [textRef, formError]);
    useEffect(function () {
        var errorMessage = validateAmount({
            inputValue: answerText || '',
            inputType: inputType,
            transactionAmount: transactionAmount,
            isEligibleForPartialAmount: isEligibleForPartialAmount
        });
        if (errorMessage && isAdditionalContent) {
            dispatch(updateAdditionalFieldFormError(errorMessage));
        }
        else if (errorMessage) {
            dispatch(updateFormError(errorMessage));
        }
        else {
            dispatch(clearFormError());
        }
    }, [
        answerText,
        dispatch,
        inputType,
        transactionAmount,
        isAdditionalContent,
        isEligibleForPartialAmount
    ]);
    return (_jsx(Inset, __assign({ horizontal: "base" }, { children: _jsx(CustomCLTextfield, { "aria-labelledby": formError && 'syf-help-text-syf-textfield', dataCy: dataCy, textfieldRef: textRef, error: isAdditionalContent ? additionalFieldFormError : formError, id: "syf-textfield", placeholder: placeholder, leftIcon: (questionType === FieldType.Date || inputType === TYPE_NUMBER) && (_jsx(Icon, { name: "faDollarSign", size: "xs" })), 
            // TODO: get rid of "number" input types since they don't trigger change event when typing non=numeric values, making validation herder.
            type: inputType === TYPE_NUMBER ? 'text' : inputType, value: answerText, onKeyPress: handleKeyPress, onChange: handleChange }) })));
};
export default TextField;
var templateObject_1;
//# sourceMappingURL=index.js.map